// src/components/ResetPassword.jsx
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import styles from "./ResetPasswordMb.module.css";
import logo from "../../../../assets/img/Ini_Logo_1.png";
import logo1 from "../../../../assets/img/437dc99a.jpg";
import { toast } from "react-toastify";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

const ResetPasswordMb = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
  const [apiLogo, setApiLogo] = useState(null); // State for API logo

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const key = searchParams.get("Key");
  const msid = searchParams.get("MSID");
  const userName = searchParams.get("userName");

    // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
  // Modified function for mobile compatibility - using direct URL instead of blob
  const fetchLogoFromAPI = async () => {
    try {
      // For mobile devices, use direct URL instead of blob conversion
      const logoUrl = `${window.runtimeConfig?.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/Login/GetLogo`;
      
      console.log('Mobile Reset: Attempting to fetch logo from:', logoUrl);
      
      // Test if the URL is accessible
      const testResponse = await fetch(logoUrl, { method: 'GET' });
      
      if (testResponse.ok) {
        setApiLogo(logoUrl);
        console.log('Mobile Reset: Logo URL set successfully:', logoUrl);
      } else {
        console.error('Mobile Reset: Logo URL not accessible:', testResponse.status);
        setApiLogo(null);
      }
    } catch (error) {
      console.error('Mobile Reset: Error setting logo URL:', error);
      setApiLogo(null);
    }
  };

  useEffect(() => {
    const runValidation = async () => {
      if (key && msid) {
        const result = await validateToken(key, msid);

        if (result.success) {
          setIsLoading(false);
          setValidated(true);
          console.log("Token validated:", result.data);
        } else {
          console.error("Token validation failed:", result.error);
        }
      }
    };

    runValidation();
  }, [key, msid]);

  // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
  useEffect(() => {
    fetchLogoFromAPI();
  }, []);

  const validateToken = async (key, msid) => {
    const url = `/api/Login/ValidateResetPasswordToken?Key=${key}&MSID=${msid}`;

    try {
      const response = await AxiosInstance1.post(url, { key, msid });
      const res = response?.data;

      if (res?.type === 0 && res?.message === "ValidUser") {
        return { success: true, data: res };
      } else {
        console.warn("Unexpected response status:", response.status);
        return {
          success: false,
          error: `Unexpected status: ${response.status}`,
        };
      }
    } catch (error) {
      console.error("Failed to send email:", error);
      return { success: false, error: error.message || "Unknown error" };
    }
  };

  const getEncryptedUserNameOnChange = async (username) => {
    const response = await fetch(
      `${
        window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1
      }/api/Login/getEncryptedUserNameOnChange?UserName=${encodeURIComponent(
        username
      )}`
    );
    if (!response.ok) throw new Error("Failed to get encrypted username");
    return await response.text();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords does not match.");
      toast.error("Passwords does not match.");
      return;
    }

    try {
      var username = userName;
      const encUser = await getEncryptedUserNameOnChange(username);
      const encryptedUsername = String(encUser).split("||")[0];
      let encryptedNewPassword = "";
      let encryptedConfirmPassword = "";

      // Encrypt new and confirm passwords
      for (let i = newPassword.length - 1; i >= 0; i--) {
        encryptedNewPassword += newPassword[i] + encryptedUsername + "|";
        encryptedConfirmPassword +=
          confirmPassword[i] + encryptedUsername + "|";
      }
      encryptedNewPassword = encryptedNewPassword.slice(0, -1);
      encryptedConfirmPassword = encryptedConfirmPassword.slice(0, -1);

      var url = `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/Login/ResetPassword?Key=${key}&MSID=${msid}&NewPassword=${encryptedNewPassword}&ConfirmPassword=${encryptedConfirmPassword}`;
      const res = await fetch(url, {
        method: "POST",
      });

      const response = await res.json();

      if (response?.type === 0) {
        setErrorMessage("");
        toast.success(`${response?.data}`);
        setNewPassword("");
        setConfirmPassword("");
      } else if (response?.type === 1) {
        setMessage("");
        toast.error(response?.data);
      } else {
        setMessage("");
        toast.error(`Unexpected status: ${response.status}`);
      }
    } catch (error) {
      setMessage("");
      toast.error(error.message || "An error occurred.");
    }
  };

  if (isLoading)
    return <div className={styles.loadingContainer}>Loading...</div>;
  if (!validated)
    return <div className={styles.messageContainer}>{message}</div>;

  return (
    <div className={`${styles.resetPage}`}>
      <div className={styles.outerContainer}>
        <div className={styles.innerContainer}>
          {/* Logo Section */}
          <div className="text-center mb-1 d-xs-flex justify-content-between align-items-center">
                <img
                  src={logo}
                  alt="Winsights Logo"
                  className="img-fluid"
                  style={{
                    width: "45%",
                    maxWidth: "120px",
                    borderRight: "1px solid #ccc",
                    paddingRight: "10px",
                  }}
                />
                 {/* Added by Gauri to show logo on login page from Company Information page on 25-09-2025 */}
                 {apiLogo ? (
                   <img
                     src={apiLogo}     // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
                     alt="Company Logo"
                     className="img-fluid"
                     style={{
                       width: "45%",
                       maxWidth: "120px",
                       paddingLeft: "10px",
                       objectFit: "contain", // Ensure proper scaling
                       height: "auto", // Maintain aspect ratio
                     }}
                     onLoad={() => console.log('Mobile Reset: Logo loaded successfully')}
                     onError={(e) => {
                       console.log('Mobile Reset: Logo failed to load, falling back to blank space');
                       setApiLogo(null);
                     }}
                     crossOrigin="anonymous" // Handle CORS if needed
                     loading="lazy" // Optimize loading for mobile
                     decoding="async" // Better performance on mobile
                   />
                 ) : (
                   <div
                     className="img-fluid"
                     style={{
                       width: "45%",
                       maxWidth: "120px",
                       paddingLeft: "10px",
                       height: "80px",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                     }}
                   >
                     {/* Blank space when no logo */}
                   </div>
                 )}
              </div>

          {/* Header Section */}
          <div className={`text-center ${styles.headerSection}`}>
            <h4 className={styles.title}>
              <strong>Reset Password</strong>
            </h4>
            <p className={styles.subtitle}>You can reset your password here.</p>
          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} className={styles.resetForm}>
            <div className={styles.formGroup}>
              <label htmlFor="newPassword" className={styles.formLabel}>
                New Password
              </label>
              <input
                type="password"
                id="newPassword"
                className={styles.formInput}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                placeholder="Enter new password"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="confirmPassword" className={styles.formLabel}>
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                className={styles.formInput}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Confirm new password"
              />
            </div>

            <button type="submit" className={styles.resetButton}>
              Reset Password
            </button>

            {/* Message Section */}
            {/* {(message || errorMessage) && (
              <div
                className={`${styles.message} ${
                  message ? styles.successMessage : styles.errorMessage
                }`}
              >
                {message || errorMessage}
              </div>
            )} */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordMb;
